import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleSection from './components/ArticleSection';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <section id="categorias">
        <CategoryGrid />
      </section>
      <section id="artigos">
        <ArticleSection />
      </section>
      <TestimonialSection />
      <section id="guia-compras">
        <CtaSection />
      </section>
      <Footer />
    </main>
  );
}